// ── 로그데이터 저장(다운로드/인쇄) 공용 헬퍼 ───────────────────────────
// 엑셀 내보내기/PDF 저장/화면 인쇄는 브라우저에서 바로 처리되어(서버를 거치지 않음) 서버가
// 알 수 없으므로, 각 화면에서 다운로드·인쇄 버튼을 눌렀을 때 이 헬퍼로 서버에 "방금 이런
// 다운로드/인쇄가 있었다"를 알려줍니다. 화면 동작을 막으면 안 되므로 실패해도 조용히
// 무시합니다(fire-and-forget). 로그인/수정 로그는 서버가 자동으로 남기므로 여기서 다루지 않습니다.
import API from '../api';

export const logDownload = (menu, fileName) => {
  API.post('/logs/event', { category: 'download', menu, name: fileName }).catch(() => {});
};

export const logPrint = (menu, listName) => {
  API.post('/logs/event', { category: 'print', menu, name: listName }).catch(() => {});
};